import React, { useState } from "react";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import "./Footer.scss";

const Footer = () => {
  const[formData, setFormData] = useState({name:"", email:"", message:""});
  // this will help us to know whether the form is submitted or not
  const[isFormSubmitted, setIsFormSubmitted] = useState(false);
  const[loading, setLoading] = useState(false);

  //destructuring the formData
  const{name, email, message} = formData;
  
  //this fucntion will accept a key press event
  const handleChangeInput = (e) => {
    //it will get the name and the value of the input field, and then we can dynamically set the value of the desired input field
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  }

  const handleSubmit = () => {
    setLoading(true);

    const contact={
      _type:'contact',
      name:name,      //as we have destructured the formData, we can directly use the name, email, message
      email:email,
      message:message,
    }
    client.create(contact)
     .then(()=>{
      setLoading(false);
      setIsFormSubmitted(true);
     })
  
  }
  return (
    <>
      <h2 className="head-text">Chat with me!</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:2021cssb1271@iitrpr.ac.in" className="p-text">2021csb1271@iitrpr.ac.in</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="email" />
          <a href="tel:+91 9521641071" className="p-text">+91 9521641071</a>
        </div>
      </div>

{!isFormSubmitted?

      <div className="app__footer-form app__flex">
        <div className="app__flex"> 
          <input className="p-text" type="text" placeholder="Your Name" name="name" value={name} onChange={handleChangeInput}/>
          </div> 
          <div className="app__flex"> 
          <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput}/>
          </div> 
          <div>
            <textarea
            className="p-text"
            placeholder="Your Message"
            name="message"
            value={message}
            onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text"  onClick={handleSubmit}>{loading?"Sending Message":"Send Message"}</button> 
          
      </div>
 : <div>
  <h3 className="p-text">Thank you for contacting me!</h3>
</div>
}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
